import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import addBtn from '../../assets/images/prelimAdd.svg'
import deleteBtn from '../../assets/images/delete.svg'
import editBtn from '../../assets/images/edit.svg'
import './Notes.scss'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress } from '@mui/material'
import * as routes from '../../routes/route'
import GuestDetailsHeader from '../../components/GuestDetailsHeader/GuestDetailsHeader'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import openEyeBtn from '../../assets/images/eye-open.svg'
import closeEyeBtn from '../../assets/images/eye-close.svg'
import  {ReactComponent as AddIcon} from '../../assets/images/add.svg'
import  {ReactComponent as LeftArrow} from '../../assets/images/left-arrow.svg'
import  {ReactComponent as RightArrow} from '../../assets/images/right-arrow.svg'
import {clearConsultationNotes, deleteConsultationNotes, downloadConsultationNotesExcel, getConsultationNotes, updateConsultationNotesVisibleStatus} from '../../redux/actions/GuestDataActions/ConsultationNotesActions'
import ChangeVisibilityModal from '../../components/ChangeVisibilityModal/ChangeVisibilityModal'
import arrowDownIcon from '../../assets/images/arrow-down-brown.svg'
import { parseJSON } from '../../utils/helpers/universalFunctions'
import { ViewDietaryNotes } from './Forms/DietaryNotes/ViewDietaryNotes'
import {ReactComponent as FileIcon} from '../../assets/images/file.svg'
import { ViewVitalsCheck } from './Forms/VitalsCheck/ViewVitalsCheck'
import { ViewLabTests } from './Forms/LabTests/ViewLabTests'
import { ViewAyurvedaArrivalConsultation } from './Forms/AyurvedaArrivalConsultation/ViewAyurvedaArrivalConsultation'
import { ViewYogaArrivalConsultation } from './Forms/YogaArrivalConsultation/ViewYogaArrivalConsultation'
import { ViewTCMArrivalConsultation } from './Forms/TCMArrivalConsultation/ViewTCMArrivalConsultation'
import { ViewPhysioArrivalConsultation } from './Forms/PhysioArrivalConsultation/ViewPhysioArrivalConsultation'
import { ViewAyurvedaDepartureConsultation } from './Forms/AyurvedaDepartureConsultation/ViewAyurvedaDepartureConsultation'
import { ViewTCMDepartureConsultation } from './Forms/TCMDepartureConsultation/ViewTCMDepartureConsultation'
import { DEPARTURE, nonSessionNotes, notesTypesName } from './Forms/NoteFormsConstants'
import { ViewYogaDepartureConsultation } from './Forms/YogaDepartureConsultation/ViewYogaDepartureConsultation'
import { ViewPhysioDepartureConsultation } from './Forms/PhysioDepartureConsultation/ViewPhysioDepartureConsultation'
import { ViewPostStayConsultation } from './Forms/PostStayConsultation/ViewPostStayConsultation'
import { ViewFitnessArrivalConsultation } from './Forms/FitnessArrivalConsultation/ViewFitnessArrivalConsultation'
import { ViewFitnessDepartureConsultation } from './Forms/FitnessDepartureConsultation/ViewFitnessDepartureConsultation'
import backArrow from '../../assets/images/back-arrow.svg'

const dynamicNotesType = [
  { title: notesTypesName.DIETRY_NOTES, component: ViewDietaryNotes , hideVisibilityIcon: true},
  { title: notesTypesName.VITALS_CHECK, component: ViewVitalsCheck , hideVisibilityIcon: true, showExcelView: true},
  // { title: 'Vitals Check - Departure', component: ViewVitalsCheck, type: DEPARTURE, hideVisibilityIcon: true, showExcelView: true},
  { title: notesTypesName.LAB_TESTS, component: ViewLabTests , hideVisibilityIcon: true, showExcelView: true},
  // { title: 'Lab Tests - Departure', component: ViewLabTests, type: DEPARTURE , hideVisibilityIcon: true, showExcelView: true},
  { title: 'Ayurveda Arrival Consultation', component: ViewAyurvedaArrivalConsultation , hideVisibilityIcon: true},
  { title: 'Ayurveda Departure Consultation', component: ViewAyurvedaDepartureConsultation , hideVisibilityIcon: true},
  { title: 'Yoga Arrival Consultation', component: ViewYogaArrivalConsultation , hideVisibilityIcon: true},
  { title: 'Yoga Departure Consultation', component: ViewYogaDepartureConsultation , hideVisibilityIcon: true},
  { title: 'Physio Arrival Consultation', component: ViewPhysioArrivalConsultation , hideVisibilityIcon: true},
  { title: 'Physio Departure Consultation', component: ViewPhysioDepartureConsultation , hideVisibilityIcon: true},
  { title: 'TCM Arrival Consultation', component: ViewTCMArrivalConsultation , hideVisibilityIcon: true},
  { title: 'TCM Departure Consultation', component: ViewTCMDepartureConsultation , hideVisibilityIcon: true},
  { title: 'Fitness Arrival Consultation', component: ViewFitnessArrivalConsultation , hideVisibilityIcon: true},
  { title: 'Fitness Departure Consultation', component: ViewFitnessDepartureConsultation , hideVisibilityIcon: true},
  { title: 'Post Stay Consultation', component: ViewPostStayConsultation , hideVisibilityIcon: true},
]


function Notes() {
    const location = useLocation();
    const { guestId, userProgramId, type, date} = location.state;
    const [currentDate, setCurrentDate] = useState(date || moment().format('YYYY-MM-DD'))
    const consultationNotesData = useSelector(state=> state.consultationNotesReducer)
    const permissions = JSON.parse(localStorage.getItem('UserData'))?.permissions;
    const {loading, guestDetails} = useSelector(state=> state.guestDetailsReducer)
    
    
    const canWrite = (permissions?.consultation_notes?.permissions || '').includes('write') || (permissions?.dietary_notes?.permissions || '').includes('write')
    const dispatch = useDispatch()
    const navigate = useNavigate()

    // const handleChangeDate = (num) => {
    //   let newDate = moment(date).add(num, 'day').format('YYYY-MM-DD');
    //   navigate(routes.VIEW_CONSULTATION_NOTES_ENDPOINT, { 
    //     replace: true, 
    //     state: {guestId, userProgramId, type, date: newDate}
    //   })
    // }

    const handleAdd = ()=>{
      navigate(routes.ADD_CONSULTATION_NOTES_ENDPOINT, { 
        state: {guestId, userProgramId, type, date: currentDate, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`}
      })
    }



    useEffect(()=>{
        if(guestId && userProgramId){
            dispatch(getConsultationNotes({guestId, userProgramId, date: ''}))
        }

        return(()=>{
          dispatch(clearConsultationNotes())
        })
    },[])


  return (
        <>
            <div className="consultation-notes-container">
                <div className="container h-100">
                  <div className="consultation-notes-heading d-flex align-items-center">
                  <img className='back-arrow me-3' src={backArrow} width={'23px'} alt="" onClick={()=>navigate(-1)} />
                      Consultant Recommendations
                  </div>

                    {   loading && (guestId !== guestDetails?.user_id || !guestDetails) ?
                        <div className="loader">
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>

                        :

                        <div className="pt-4 pb-5">
                            <div className="consultation-notes-content">
                                <GuestDetailsHeader guestId={guestId} />
                                {/* <div className='d-flex note-header items-center'>
                                  <div className="prev-next-btn d-flex justify-content-between items-center mx-2 flex-grow-1">
                                    <button type='button'  className='next-btn' onClick={()=>{handleChangeDate(-1)}}><LeftArrow/>  Prev</button>
                                    <div className='time my-auto'>{moment(new Date(currentDate)).format('MMM DD, YYYY')}</div>
                                    <button type='button'  className='prev-btn' disabled={currentDate === moment().format('YYYY-MM-DD')} onClick={()=>{handleChangeDate(1)}}>Next <RightArrow/></button>
                                  </div>
                                </div> */}
                                {/* <div className='d-flex note-header justify-content-end'>
                                  {
                                    !!consultationNotesData?.consultationNotesData?.length && canWrite &&
                                    <button className="add-btn flex-shrink-1 mx-2 d-flex items-center justify-content-between" type='submit' 
                                      onClick={handleAdd}
                                    >
                                      <AddIcon />
                                      <span>Add Note</span>
                                    </button>
                                  }
                                </div> */}
                                {
                                    consultationNotesData?.loading ? 
                                    <div className="loader">
                                        <CircularProgress sx={{'color': '#74613C'}} size={20}/>
                                    </div>
                                    :
                                    <>
                                        {
                                            (!consultationNotesData?.consultationNotesData?.length) ?
                                            
                                            <div className="guest-add">
                                                {
                                                    canWrite
                                                    ?
                                                    <div data-testid="add-btn" className="add" onClick={handleAdd}>
                                                        <img src={addBtn} width={40} alt="" />
                                                        <div className='text'>Add Note</div>
                                                    </div>
                                                    :
                                                    null
                                                }
                                            </div>
                                            :
                                            <div className='all-notes'>
                                              {
                                                consultationNotesData?.consultationNotesData?.map((item, index)=>{
                                                  let canNotView = (item?.notice_type !== notesTypesName.DIETRY_NOTES ? (permissions?.consultation_notes?.permissions || '').includes('hide') : (permissions?.dietary_notes?.permissions || '').includes('hide'))
                                                  
                                                  if(canNotView){
                                                    return null
                                                  }
                                                  

                                                  return (
                                                    <React.Fragment key={index}>
                                                      {
                                                        item.notes_type===notesTypesName.DIETRY_NOTES && permissions?.dietary_notes?.permissions === 'hide' ?
                                                        null:
                                                        <>
                                                          <GroupedNotes 
                                                            type={type}
                                                            data={item}
                                                            guestId={guestId}
                                                            userProgramId={userProgramId}
                                                            guestDetails={guestDetails}
                                                            currentDate={currentDate}
                                                          />
                                                        </>
                                                      }
                                                    </React.Fragment>
                                                  )
                                                })
                                              } 
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    }                
                </div>
            </div>
        </>
  )
}

export default Notes


function GroupedNotes({data, guestId, userProgramId, guestDetails, type, currentDate}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const notesFilters = [...searchParams.entries()].filter(item=>item[0]==="notesType").map(item=>item[1])
  const [toggle, setToggle] = useState(notesFilters?.length ? notesFilters.includes(data.notice_type) : true);
  const permissions = JSON.parse(localStorage.getItem('UserData'))?.permissions;
  let currentNote = dynamicNotesType.find(item => item.title === data.notice_type)
  let canWrite = data.notice_type !== notesTypesName.EMOTIONAL_HEALING_NOTES && (data?.notice_type !== notesTypesName.DIETRY_NOTES ? (permissions?.consultation_notes?.permissions || '').includes('write') : (permissions?.dietary_notes?.permissions || '').includes('write'))
  const navigate = useNavigate()

  const handleAdd = ()=>{
    navigate(routes.ADD_CONSULTATION_NOTES_ENDPOINT, { 
      state: {guestId, userProgramId, type, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`, date: moment().format('YYYY-MM-DD'), noteTypeName: data.notice_type}
    })
  }



  return (
    <div className='px-3 group-notes'>
      <Accordion 
        expanded={toggle}
        onChange = {(e,expanded) => {
          if(expanded){
              setToggle(true)
          }else{
              setToggle(false)
          }
      }}>
          <AccordionSummary
            expandIcon={<img src={arrowDownIcon}/>}
            aria-controls="panel2a-content"
            id="panel2a-header"
            >
          <div className='accordian-title ms-3  d-flex justify-content-between align-items-center py-2 w-100'>
              {data.notice_type}
              {
                canWrite &&
                <button className="add-btn flex-shrink-0 mx-2 d-flex items-center justify-content-between" type='submit' 
                  onClick={handleAdd}
                >
                  <AddIcon />
                  <span>Add Note</span>
                </button>
              }
          </div>
          </AccordionSummary>
          <AccordionDetails>
            {
              currentNote && currentNote?.showExcelView && data?.list?.length>0 ? 
              <div className='ms-4'>
                {React.createElement(currentNote.component, {content: data?.list, guestId, userProgramId, date: currentDate, guestDetails})}
              </div>
              :
              <>
                {
                  !nonSessionNotes.includes(data.notice_type) && data?.list?.length>0 &&
                  <div className='row ms-md-5 mb-0 heading my-3'>
                    <div className='col-2'>SESSION</div>
                    <div className='col-2'>SESSION DATE</div>
                    <div className='col-2'>SESSION BY</div>
                    <div className='col-2'>SESSION NOTE</div>
                    <div className='col-2'>NOTE POSTED ON</div>
                    <div className='col-2'>VISIBLE TO GUEST</div>
                  </div>
                }
                {
                  data?.list?.map((item, index)=>{
                    return (
                      <React.Fragment key={item?.note_id}>
                        {
                          item.notes_type===notesTypesName.DIETRY_NOTES && permissions?.dietary_notes?.permissions === 'hide' ?
                          null:
                          <>
                            <SingleNote 
                              note={item}
                              guestId={guestId}
                              userProgramId={userProgramId}
                              type={type}
                              currentDate={currentDate}
                            />
                            {data?.list?.length !== index+1 && <div className="hr"></div>}
                          </>
                        }
                      </React.Fragment>
                    )
                  })
                }
              </>
            }
          </AccordionDetails>
      </Accordion>
    </div>
  )
}

function SingleNote({note, userProgramId, guestId, type, currentDate}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const notesFilters = [...searchParams.entries()].filter(item=>item[0]==="notesType").map(item=>item[1])
  const [toggle, setToggle] = useState(notesFilters?.length ? notesFilters.includes(note.notes_type) : false);
  const [deleteModal, setDeleteModal] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [visibilityModal, setVisibilityModal] =useState(false)
  const [eye, setEye] = useState(note?.is_guest_visible)
  const permissions = JSON.parse(localStorage.getItem('UserData'))?.permissions;
  const userData = JSON.parse(localStorage.getItem('UserData'));
  const canWriteNote = (permissions?.consultation_notes?.permissions || '').includes('write')
  // const canWriteDietNote = (permissions?.dietary_notes?.permissions || '').includes('write')
  const canWrite = (note.notes_type !== notesTypesName.DIETRY_NOTES &&  canWriteNote) && (!note.is_note_exist ? true: note?.user_id === userData?.user_id) && note.notes_type !== notesTypesName.EMOTIONAL_HEALING_NOTES
  const {guestDetails} = useSelector(state=> state.guestDetailsReducer)
  let isJSONNote = dynamicNotesType.find(item => item.title === note.notes_type)
  let canChangeVisibility = note.notes_type !=='Therapist Notes'

  const deleteNote  = (id, noteType, docs) =>{
    dispatch(deleteConsultationNotes({noteId: id, noteType, docs, sessionId: note?.session_id, guestId, userProgramId}))
    setDeleteModal(false)
  }
  
  const handleEye = ()=>{
    setEye(!eye); 
    dispatch(updateConsultationNotesVisibleStatus({noteId: note?.note_id, isVisible: !eye}))
    setVisibilityModal(false)
}

  const handleAddNavigate=()=>{
    navigate(routes.ADD_CONSULTATION_NOTES_ENDPOINT, { 
      state: {guestId, userProgramId, type, date: currentDate, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`, sessionId: note.session_id, noteTypeName: note?.notes_type}
    })
  }

  const handleEditNavigate=()=>{
    navigate(routes.EDIT_CONSULTATION_NOTES_ENDPOINT, {state: { noteId: note?.note_id, guestId, userProgramId, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`}})
  }

  return (
    
    <div className='ms-3 ps-1'>
      <Accordion 
        expanded={note?.is_note_exist ? toggle : false}
        onChange = {(e,expanded) => {
          if(expanded){
              setToggle(true)
          }else{
              setToggle(false)
          }
      }}
      style={{border: 0}}
      
      >
          <AccordionSummary
            expandIcon={<img src={arrowDownIcon}/>}
            aria-controls="panel2a-content"
            id="panel2a-header"
            // sx={{
            //   cursor: note?.is_note_exist ? 'pointer' : 'not-allowed',
            // }}
            >
          <div className='accordian-title w-100 '>
            <div className="d-flex justify-content-between align-items.center">
              {
                nonSessionNotes.includes(note.notes_type) ? 
                <div className='note-title d-flex justify-content-between align-items-center ms-4'>
                  <div className="note-footer d-flex justify-content-between flex-grow-1 align-items-center">
                    <div className='added-by'>Added By:  <span className='d-block d-md-inline'> {note?.first_name+ ' ' + note?.last_name}</span></div>
                    <div className='text-muted'>Updated On: <span className='d-block d-md-inline'> {moment(note?.f_updation_datetime).format('dddd, DD MMM')}</span></div>
                  </div>
                  <div className="icons">
                    {
                      canWrite ?
                      <>
                        <>
                          <div className="vhr"></div>
                          {!isJSONNote?.hideVisibilityIcon && canChangeVisibility && <img src={eye ? openEyeBtn : closeEyeBtn} alt="eye-btn" className="" onClick={()=>setVisibilityModal(true)}/>}
                          <img src={editBtn} alt="edit-btn" className="" onClick={()=>navigate(routes.EDIT_CONSULTATION_NOTES_ENDPOINT, {state: { noteId: note?.note_id, guestId, userProgramId, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`}})}/>
                          <img src={deleteBtn} alt="del-btn" className="" onClick={()=>setDeleteModal(true)}/>
                        </>
                      </>
                      :
                      <>
                        {
                          !!note?.is_guest_visible && note.notes_type !== "Dietary Notes" &&
                          <>
                            <div className="vhr"></div>
                            <div className='view-permission'>Visible to Guest</div>
                          </>
                        }
                      </>
                    }
                  </div>
                </div>
                :
                <div className='row ms-md-3 note-title heading my-3'>
                    <div className='col-2'>{note.session_name || '-'}</div>
                    <div onClick={note?.session_date && canWrite ? (!note?.is_note_exist ? handleAddNavigate : handleEditNavigate): undefined} className={`col-2 ${note?.session_date && canWrite? 'text-underline': ''} ${!note?.is_note_exist ? 'text-red': ''}`}>{note?.session_date ? `${note?.session_date} | ${note?.session_time}` : '-'}</div>
                    <div className='col-2'>{note?.assigned_therapist ? `${note?.assigned_therapist}` : '-'}</div>
                    <div className='col-2'>{note?.notes_type || '-'}</div>
                    <div className='col-2'>{note?.notes_creation_date || '-'}</div>
                    <div className='col-2'>
                      {
                        !!note?.is_note_exist ?
                        <>
                          {note?.is_guest_visible ? "Yes" : "No"}
                          {
                            canWrite &&
                            <>
                                {!isJSONNote?.hideVisibilityIcon && canChangeVisibility && <img src={eye ? openEyeBtn : closeEyeBtn} alt="eye-btn" className="ms-2" onClick={()=>setVisibilityModal(true)}/>}
                            </>
                          }
                        </>
                        :
                        "-"
                      }
                    </div>
                  </div>

              }

            </div>
          </div>
          </AccordionSummary>
          <AccordionDetails>
            {
              note.is_note_exist &&
              <div className="ms-md-4 ps-1 accordian-details">
                {
                  canWrite && !nonSessionNotes.includes(note?.notes_type) &&
                  <div className="text-end text-red mt-2 cursor-pointer" onClick={()=>setDeleteModal(true)}>
                    Delete note<img src={deleteBtn} alt="del-btn" className="ms-1" />
                  </div>
                }
                {
                  isJSONNote?
                  React.createElement(isJSONNote.component, {content: parseJSON(note?.notes_detail) || "", type:isJSONNote.type, guestName: `${guestDetails?.first_name} ${guestDetails?.last_name}`, conductedBy: note?.assigned_therapist || "" })
                  :
                  <div className='quilDiv ms-1'>
                    <ReactQuill
                        className='quillMainDiv'
                        theme="snow"
                        value={note?.notes_detail}
                        readOnly={true}
                    />
                </div>

                }
                <div className='d-flex mb-3 ms-1'>
                  <div className="fw-semi-bold me-2 flex-shrink-0">Uploaded Files:</div>
                  <div className="text-break ">
                    {
                      note?.docs?.length>0 &&note?.docs?.map((item, index)=>{
                        return(
                          <Link className='d-flex align-items-center text-decoration-none mb-2 fw-semi-bold' target="_blank"  to={note?.docs_url?.[index]} key={index}>
                            <FileIcon width={13}/> &nbsp;
                            {item?.split('-').slice(1).join('-')}
                          </Link>
                        )
                      })
                    }
                    {
                      note?.notes_doc?.length>0 ? note.notes_doc?.map((item, index)=>{
                        return(
                          <Link className='d-flex align-items-center text-decoration-none mb-2 fw-semi-bold' target="_blank"  to={note.notes_url[index]} key={index}>
                            <FileIcon width={13}/> &nbsp;
                            {item?.split('-').slice(1).join('-')}
                          </Link>
                        )
                      })

                      :
                      '-'
                    }
                </div>
                </div>
              </div>
            }
          </AccordionDetails>
      </Accordion>
      
      
      
      <ChangeVisibilityModal
        warnModal={visibilityModal} 
        setWarnModal={setVisibilityModal} 
        onYes={handleEye}
        hide={eye}
        />
      <DeleteModal 
          deleteModal={deleteModal} 
          setDeleteModal={setDeleteModal}
          name="this note"
          onDelete = {()=>deleteNote(note?.note_id, note?.notes_type, note.notes_doc) }
      />
    </div>
  )
}